import { MaterialSymbol } from '@florencelabs/icons';
import clsx from 'clsx';
import { PropsWithChildren, ReactElement } from 'react';

export const EmptyStateShell = ({
  children,
}: PropsWithChildren): ReactElement => {
  return (
    <div
      className={clsx(
        'flex h-min flex-col items-center gap-6 rounded-lg bg-primary-100 mix-blend-multiply tablet:col-span-3',
        'tablet:px-18 px-8 py-10 tablet:py-20',
      )}
    >
      <div className={'text-primary-color'} aria-hidden={'true'}>
        <MaterialSymbol name={'error_fill'} size={40} />
      </div>
      {children}
    </div>
  );
};
